import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogUERBaseCostWorkScopesGql } from '../../../catalogUerBaseCostQueries';

interface IUseCatalogUERBaseCostWorkScopes {
    catalogUniqueId?: string;
    uerBaseCostId?: number;
    withEffect?: boolean;
}

const requestId = 'catalogUERBaseCostWorkScopes';

export const useCatalogUERBaseCostWorkScopes = (props: IUseCatalogUERBaseCostWorkScopes) => {
    const dispatch = useDispatch();
    const { catalogUniqueId, uerBaseCostId, withEffect } = props;

    const variables = useMemo(
        () => (catalogUniqueId && uerBaseCostId ? { catalogUniqueId, uerBaseCostId } : undefined),
        [catalogUniqueId, uerBaseCostId],
    );

    const [catalogUERBaseCostWorkScopesReset] = useResetStoreData({ requestId });

    const [
        catalogUERBaseCostWorkScopesData,
        catalogUERBaseCostWorkScopesStatus,
        ,
        catalogUERBaseCostWorkScopesRequest,
    ] = useRequest({
        requestId,
        query: catalogUERBaseCostWorkScopesGql,
        variables,
        withEffect: !!variables && withEffect,
    });

    useEffect(() => {
        catalogUERBaseCostWorkScopesReset(undefined);
    }, [catalogUERBaseCostWorkScopesReset]);

    const items = useMemo(
        () => catalogUERBaseCostWorkScopesData?.catalogUERBaseCostWorkScopes?.items || [],
        [catalogUERBaseCostWorkScopesData?.catalogUERBaseCostWorkScopes],
    );

    const refresh = useCallback(() => {
        dispatch(catalogUERBaseCostWorkScopesRequest(variables));
    }, [catalogUERBaseCostWorkScopesRequest, dispatch, variables]);

    return {
        status: catalogUERBaseCostWorkScopesStatus,
        items,
        refresh,
    };
};
